var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiau(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H28C34.6274 0 40 5.37258 40 12V28C40 34.6274 34.6274 40 28 40H12C5.37258 40 0 34.6274 0 28V12Z",
    fill: "#057DCD",
    fillOpacity: 0.094
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.1667C20.001 13.8334 19.9353 13.5032 19.8068 13.1957C19.6784 12.8881 19.4897 12.6094 19.2519 12.3758C19.0141 12.1422 18.732 11.9586 18.4222 11.8356C18.1124 11.7127 17.7812 11.6529 17.4479 11.6598C17.1147 11.6668 16.7862 11.7403 16.4818 11.8761C16.1774 12.0118 15.9032 12.2071 15.6754 12.4503C15.4475 12.6936 15.2706 12.98 15.1551 13.2926C15.0395 13.6053 14.9877 13.9379 15.0025 14.2708C14.5127 14.3968 14.0579 14.6325 13.6727 14.9603C13.2875 15.288 12.9819 15.6991 12.7791 16.1624C12.5762 16.6257 12.4815 17.1291 12.502 17.6344C12.5225 18.1398 12.6578 18.6338 12.8975 19.0792C12.476 19.4216 12.1445 19.8619 11.932 20.3616C11.7194 20.8614 11.6322 21.4055 11.6778 21.9467C11.7235 22.4878 11.9007 23.0096 12.194 23.4667C12.4873 23.9237 12.8879 24.3022 13.3609 24.5692C13.3025 25.021 13.3373 25.4801 13.4633 25.9179C13.5892 26.3558 13.8036 26.7632 14.0932 27.115C14.3827 27.4667 14.7414 27.7554 15.1469 27.9631C15.5524 28.1709 15.9962 28.2933 16.4508 28.3228C16.9055 28.3523 17.3614 28.2883 17.7903 28.1347C18.2193 27.9811 18.6122 27.7412 18.9448 27.4298C19.2774 27.1184 19.5427 26.7421 19.7242 26.3242C19.9056 25.9063 19.9995 25.4556 20 25V14.1667Z",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.1667C19.999 13.8334 20.0647 13.5032 20.1932 13.1957C20.3217 12.8881 20.5103 12.6094 20.7481 12.3758C20.9859 12.1422 21.268 11.9586 21.5778 11.8356C21.8876 11.7127 22.2189 11.6529 22.5521 11.6598C22.8853 11.6668 23.2138 11.7403 23.5182 11.8761C23.8226 12.0118 24.0968 12.2071 24.3247 12.4503C24.5525 12.6936 24.7294 12.98 24.845 13.2926C24.9605 13.6053 25.0124 13.9379 24.9975 14.2708C25.4873 14.3968 25.9421 14.6325 26.3273 14.9603C26.7125 15.288 27.0181 15.6991 27.221 16.1624C27.4238 16.6257 27.5185 17.1291 27.498 17.6344C27.4775 18.1398 27.3422 18.6338 27.1025 19.0792C27.524 19.4216 27.8555 19.8619 28.0681 20.3616C28.2806 20.8614 28.3679 21.4055 28.3222 21.9467C28.2765 22.4878 28.0993 23.0096 27.806 23.4667C27.5127 23.9237 27.1121 24.3022 26.6392 24.5692C26.6976 25.021 26.6627 25.4801 26.5368 25.9179C26.4108 26.3558 26.1964 26.7632 25.9069 27.115C25.6173 27.4667 25.2587 27.7554 24.8532 27.9631C24.4477 28.1709 24.0039 28.2933 23.5492 28.3228C23.0945 28.3523 22.6386 28.2883 22.2097 28.1347C21.7807 27.9811 21.3878 27.7412 21.0552 27.4298C20.7226 27.1184 20.4574 26.7421 20.2759 26.3242C20.0944 25.9063 20.0005 25.4556 20 25V14.1667Z",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 20.8333C21.8004 20.5872 21.1894 20.1392 20.7444 19.5458C20.2994 18.9525 20.0404 18.2406 20 17.5C19.9596 18.2406 19.7006 18.9525 19.2556 19.5458C18.8106 20.1392 18.1996 20.5872 17.5 20.8333",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6658 15.4167C24.8675 15.0671 24.9816 14.674 24.9983 14.2708",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0025 14.2708C15.019 14.6739 15.1328 15.0671 15.3342 15.4167",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8975 19.08C13.05 18.9558 13.2131 18.8454 13.385 18.75",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.615 18.75C26.7869 18.8454 26.95 18.9558 27.1025 19.08",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25C14.4257 25.0003 13.8611 24.8521 13.3608 24.57",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6392 24.57C26.1389 24.8521 25.5743 25.0003 25 25",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiau);
export default __webpack_public_path__ + "static/media/Ai&au.847d4f2b9f79746126ad0b51f1e6b098.svg";
export { ForwardRef as ReactComponent };